import React, { useEffect, useRef } from 'react';
import './ProjectDetails.css';

const ProjectBrandDetail = () => {

    const bannerRef = useRef(null);

    const scrollToContent = () => {
        if (bannerRef.current) {

            const bannerBottom = bannerRef.current.offsetHeight;


            window.scrollTo({
                top: bannerBottom,
                behavior: 'smooth'
            });
        }
    };


    useEffect(() => {
        const handleScroll = () => {
            if (!bannerRef.current) return;

            const bannerHeight = bannerRef.current.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY < bannerHeight - 80) {
                document.body.classList.add('nav-especial');
            } else {
                document.body.classList.remove('nav-especial');
            }
        };

        window.addEventListener('scroll', handleScroll);


        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.classList.remove('nav-especial');
        };
    }, []);


    return (
        <div className="pds-main-wrapper">
            <div className="moti-banner-full" ref={bannerRef}>
                <img
                    src="../images/AE/AE.jpg"
                    alt="Banner Principal"
                    className="moti-banner-img"
                />
                <div className="moti-banner-content">
                    <span className='moti-banner-mini'>American Eagle</span>
                    <h1 className="moti-banner-title">Neón w/Domelipa</h1>
                    <span
                        className='moti-banner-button'
                        onClick={scrollToContent}
                        style={{ cursor: 'pointer' }} 
                    >
                        Conoce el proyecto
                        <img
                            src="../images/AE/chevron.png"
                            alt="Banner Principal"
                            className="moti-banner-extra"
                        />
                    </span>
                </div>
            </div>
            <div className="pds-content-card">
                {/* Header con indicadores */}
                <header className="pds-header-group">
                    <img
                        src="/images/logo/MotiPuntos.svg"
                        alt="dots"
                        className="blog-moti-dots"
                    />
                    <p className="pds-label-top">CONOCE EL PROYECTO</p>
                    <h1 className="pds-main-title">Conociendo la marca y sus objetivos</h1>
                </header>

                <div className="pds-sections-container">
                    {/* Bloque 1: American Eagle */}
                    <div className="pds-feature-block">
                        <div className="pds-text-column">
                            <span className="pds-badge pds-bg-mint"> <img src="../images/AE/r.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading">American Eagle</h2>
                            <p className="pds-description">
                                Una de las marcas de moda juvenil más reconocidas a nivel internacional, buscaba impulsar la visibilidad de su colaboración especial con Domelipa,
                                una de las creadoras de contenido más influyentes del país.
                                <br />

                                El objetivo principal del proyecto era generar impacto visual,
                                reforzar el concepto de la campaña y atraer a su público dentro del punto de venta.
                                <br /> <br />


                                <span className="pds-badge pds-bg-peach"><img src="../images/AE/trazo.png" alt="Img 1" /></span>
                                <h2 className="pds-section-heading">Entendiendo el espacio para diseñar con propósito</h2>
                                La intervención se realizó en tiendas departamentales a nivel nacional,
                                espacios con alto flujo de consumidores y una arquitectura visual estandarizada. Esto requirió soluciones versátiles,
                                de instalación rápida y con un diseño alineado a la estética ya establecida por la marca en retail.

                            </p>
                        </div>
                        <div className="pds-visual-stack pds-bg-guide-mint">
                            <div className="pds-img-holder pds-rotate-left">
                                <img src="../images/AE/AE (6).jpg" alt="Img 1" />
                            </div>

                            <div className="pds-img-holder pds-center">
                                <img src="../images/AE/AE (2).jpg" alt="Img 2" />
                            </div>

                            <div className="pds-img-holder pds-rotate-right pds-overlay">
                                <img src="../images/AE/AE (8).jpg" alt="Img 3" />
                            </div>
                        </div>
                    </div>

                    {/* Bloque 2: Espacio (Invertido) */}
                    <div className="pds-feature-block pds-row-reverse">
                        <div className="pds-text-column-rigth">
                            <span className="pds-badge pds-bg-grape"><img src="../images/AE/foco.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading rigth">De la Idea a lo  <br /> tangible: Producción y Acabados</h2>
                            <p className="pds-description rigth">
                                Para este proyecto se utilizaron tiras LED, Kemi Board impreso con UV, lonas, acrílicos,
                                viniles, telas, MDF, PET-G y piezas en acrílico.
                                <br /><br />

                                Además, se fabricaron elementos como floor graphics, cubos MDF (raisers),
                                pisos personalizados y elementos iluminados.

                            </p>
                        </div>
                        <div className="pds-visual-grid">
                            <img src="../images/AE/AE (4).jpg" className="pds-grid-img img1" alt="Store view" />
                            <img src="../images/AE/AE (1).jpg" className="pds-grid-img img2" alt="Close up" />
                        </div>
                    </div>

                    <div className="pds-bottom-block ">
                        <span className="pds-badge pds-bg-salmon"><img src="../images/AE/can.png" alt="Img 1" /></span>
                        <h2 className="pds-section-heading rigth">¿Por qué elegimos estos materiales?</h2>
                        <p className="pds-description rigth">
                            Los materiales fueron seleccionados por su durabilidad, su capacidad para mantener colores vibrantes bajo iluminación comercial y su versatilidad para adaptarse a distintos tipos de superficies dentro del retail. La combinación de acrílicos,
                            MDF y viniles permitió construir elementos sólidos,
                            estéticos y coherentes con la identidad visual de American Eagle.
                        </p>
                        <img src="../images/AE/AE (9).jpg" className="bannerAE" alt="Close up" />
                    </div>
                    <div className="moti-container">
                        {/* Bloque: El Resultado */}
                        <section className="moti-section moti-center">
                            <div className="moti-icon-box moti-pink">
                                <span className="moti-icon"><img src="../images/AE/badge.png" alt="Img 1" /></span>
                            </div>
                            <h2 className="moti-title">El resultado: Impacto en el punto de venta</h2>
                            <p className="moti-description">
                                El proyecto cumplió satisfactoriamente el objetivo planteado: dar visibilidad a la colaboración
                                American Eagle x Domelipa y reforzar la comunicación visual dentro de las tiendas. La
                                composición final generó una presencia llamativa, coherente con la identidad juvenil de
                                ambas marcas y atractiva para su audiencia.
                            </p>
                        </section>

                        {/* Bloque: Servicios y Stack de Imágenes */}
                        <section className="moti-services-layout">
                            <div className="moti-services-text">
                                <h3 className="moti-subtitle">Servicios representados en este proyecto:</h3>

                            </div>
                            <div>
                                <ul className="moti-list">
                                    <li>• Desarrollo y ejecución de proyectos</li>
                                    <li>• Producción especializada</li>
                                    <li>• Instalación en punto de venta</li>
                                    <li>• Coordinación comercial para objetivos visuales</li>
                                </ul>
                            </div>
                        </section>
                        <div className="moti-image-stack">
                            <img src="../images/AE/AE (7).jpg" alt="Domelipa AE" className="moti-img-card moti-tilt-left" />
                            <img src="../images/AE/AE (5).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-right " />
                            <img src="../images/AE/AE (3).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-center" />
                        </div>

                        {/* Bloque: Destaque de Portafolio */}
                        <section className="moti-section moti-center">
                            <h2 className="moti-title">¿Por qué este proyecto destaca en<br /> nuestro portafolio?</h2>
                            <img
                                src="/images/logo/MotiPuntos.svg"
                                alt="dots"
                                className="blog-moti-dots"
                            />
                            <p className="moti-description">
                                Este montaje demuestra nuestra capacidad para ejecutar campañas nacionales,
                                integrando múltiples materiales, técnicas y equipos en una instalación precisa y de alto
                                impacto. Para American Eagle, representó un refuerzo visual sólido para una de sus
                                colaboraciones más relevantes; para Moti Digital, una muestra más de nuestra
                                especialidad en visual merchandising y retail execution.
                            </p>
                        </section>

                        {/* Footer Logo */}
                        <footer className="moti-brand-footer">
                            <img src="../images/AE/moti.png" alt="Img 1" className='moti-lgo' />
                            <img src="../images/AE/ready.png" alt="Img 1" className='ready' />
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectBrandDetail;